// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../uikit/atoms/Icon/IconV5.bs.js");
let Sentry = require("../reason/Sentry.bs.js");
let Scalars = require("../scalars/Scalars.bs.js");
let ButtonsV5 = require("../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Link = require("next/link").default;
let AuthSession = require("../utils/AuthSession.bs.js");
let RcSwipeout = require("rc-swipeout").default;
let AvatarSrcUrl = require("../utils/AvatarSrcUrl.bs.js");
let Avatar__Jsx3 = require("../uikit/reason/atoms/Avatar/Avatar__Jsx3.bs.js");
let Theme__Color = require("../reason/common/Theme/Theme__Color.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let AgentProfilePhoto = require("../v5/common/Agent/AgentProfilePhoto.bs.js");
let RelativeDateLabel = require("../reason/common/RelativeDateLabel.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let ReactErrorBoundary = require("react-error-boundary");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let NotificationWidgetTexts = require("../modules/Notification/components/NotificationWidgetTexts.bs.js");
let UnselectedUnionMemberError = require("../v5/common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let DevelopmentSampleUnitSummary = require("../v5/common/Development/DevelopmentSampleUnitSummary.bs.js");
let AlertsDropdownItem_alert_graphql = require("../__generated__/AlertsDropdownItem_alert_graphql.bs.js");
let Conversation__ParticipantProfilePhoto = require("../v5/conversation/Conversation__ParticipantProfilePhoto.bs.js");

let item = "flex flex-row gap-2 p-4 group";

let userPic = "flex flex-col justify-start items-center w-8";

let content = "flex-1";

let action = "";

let close = "pl-2 pt-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300";

let Styles = {
  item: item,
  userPic: userPic,
  content: content,
  action: action,
  close: close
};

let convertFragment = AlertsDropdownItem_alert_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AlertsDropdownItem_alert_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(AlertsDropdownItem_alert_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, AlertsDropdownItem_alert_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(AlertsDropdownItem_alert_graphql.node, convertFragment, fRef);
}

let Fragment_alertStatus_decode = AlertsDropdownItem_alert_graphql.Utils.alertStatus_decode;

let Fragment_alertStatus_fromString = AlertsDropdownItem_alert_graphql.Utils.alertStatus_fromString;

let Fragment_buyerNeedMatchingType_decode = AlertsDropdownItem_alert_graphql.Utils.buyerNeedMatchingType_decode;

let Fragment_buyerNeedMatchingType_fromString = AlertsDropdownItem_alert_graphql.Utils.buyerNeedMatchingType_fromString;

let Fragment_conversationContextTypeV5_decode = AlertsDropdownItem_alert_graphql.Utils.conversationContextTypeV5_decode;

let Fragment_conversationContextTypeV5_fromString = AlertsDropdownItem_alert_graphql.Utils.conversationContextTypeV5_fromString;

let Fragment_developmentProjectUnitType_decode = AlertsDropdownItem_alert_graphql.Utils.developmentProjectUnitType_decode;

let Fragment_developmentProjectUnitType_fromString = AlertsDropdownItem_alert_graphql.Utils.developmentProjectUnitType_fromString;

let Fragment = {
  alertStatus_decode: Fragment_alertStatus_decode,
  alertStatus_fromString: Fragment_alertStatus_fromString,
  buyerNeedMatchingType_decode: Fragment_buyerNeedMatchingType_decode,
  buyerNeedMatchingType_fromString: Fragment_buyerNeedMatchingType_fromString,
  conversationContextTypeV5_decode: Fragment_conversationContextTypeV5_decode,
  conversationContextTypeV5_fromString: Fragment_conversationContextTypeV5_fromString,
  developmentProjectUnitType_decode: Fragment_developmentProjectUnitType_decode,
  developmentProjectUnitType_fromString: Fragment_developmentProjectUnitType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function AlertsDropdownItem$DismissAlert(props) {
  let onDismiss = props.onDismiss;
  return JsxRuntime.jsx("a", {
    children: JsxRuntime.jsx(IconV5.make, {
      icon: "cancel"
    }),
    className: "text-zinc-500 no-underline hover:text-zinc-700",
    href: "#",
    onClick: e => {
      e.preventDefault();
      onDismiss();
    }
  });
}

let DismissAlert = {
  make: AlertsDropdownItem$DismissAlert
};

function AlertsDropdownItem$WithoutErrorBoundary(props) {
  let onDismiss = props.onDismiss;
  let alert = RescriptRelay_Fragment.useFragment(AlertsDropdownItem_alert_graphql.node, convertFragment, props.alert);
  let currentAgentId = AuthSession.useCurrentUserId();
  let s = alert.byType;
  let tmp;
  switch (s.__typename) {
    case "AgentMatchLogAlert" :
      let agentMatchLog = s.agentMatchLog;
      if (agentMatchLog !== undefined) {
        let match = agentMatchLog.byType;
        let tmp$1;
        let exit = 0;
        switch (match.__typename) {
          case "ForSalePropertyAgentMatchLogV5" :
            let match$1 = match.source.agentV2;
            switch (match$1.__typename) {
              case "VisibleForSalePropertyAgent" :
                tmp$1 = JsxRuntime.jsx(AgentProfilePhoto.make, {
                  profilePhoto: match$1.agent.fragmentRefs,
                  className: "size-[24px]"
                });
                break;
              case "AnonymousForSalePropertyAgent" :
              case "__unselected" :
                exit = 1;
                break;
            }
            break;
          case "__unselected" :
            exit = 1;
            break;
          default:
            tmp$1 = JsxRuntime.jsx(AgentProfilePhoto.make, {
              profilePhoto: match.source.agent.fragmentRefs,
              className: "size-[24px]"
            });
        }
        if (exit === 1) {
          tmp$1 = JsxRuntime.jsx(Avatar__Jsx3.make, {
            src: AvatarSrcUrl.place_holder,
            name: "Agent chose to hide their name",
            size: "micro"
          });
        }
        let s$1 = agentMatchLog.byType;
        let tmp$2;
        switch (s$1.__typename) {
          case "BuyerNeedAgentMatchLogV5" :
            tmp$2 = JsxRuntime.jsx(NotificationWidgetTexts.BuyerNeedMatchText.make, {
              aml: s$1.fragmentRefs,
              withLinks: true
            });
            break;
          case "ForSalePropertyAgentMatchLogV5" :
            tmp$2 = JsxRuntime.jsx(NotificationWidgetTexts.PropertyMatchText.make, {
              aml: s$1.fragmentRefs,
              withLinks: true
            });
            break;
          case "RentalNeedAgentMatchLogV5" :
            tmp$2 = JsxRuntime.jsx(NotificationWidgetTexts.RentalNeedMatchText.make, {
              aml: s$1.fragmentRefs,
              withLinks: true,
              mode: "Alerts"
            });
            break;
          case "RentalPropertyAgentMatchLogV5" :
            tmp$2 = JsxRuntime.jsx(NotificationWidgetTexts.RentalPropertyMatchText.make, {
              aml: s$1.fragmentRefs,
              withLinks: true
            });
            break;
          case "__unselected" :
            tmp$2 = UnselectedUnionMemberError.raise(s$1._0);
            break;
        }
        tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: tmp$1,
              className: userPic
            }),
            JsxRuntime.jsxs("div", {
              children: [
                tmp$2,
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(RelativeDateLabel.make, {
                    date: Scalars.DateTime.toUTC(alert.timestamp)
                  })
                })
              ],
              className: content
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Link, {
                href: `/match_log/` + agentMatchLog.databaseId,
                children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                  onClick: param => onDismiss(),
                  size: "small",
                  children: "View Match"
                })
              }),
              className: action
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(AlertsDropdownItem$DismissAlert, {
                onDismiss: onDismiss
              }),
              className: close
            })
          ],
          className: item
        });
      } else {
        tmp = null;
      }
      break;
    case "ConversationMessageAlert" :
      let match$2 = s.conversation;
      let match$3 = match$2.conversationContext;
      switch (match$3.__typename) {
        case "AvailableConversationContext" :
          let from = s.message.from;
          let edges = match$2.messages.edges;
          let id = match$2.id;
          let context = match$3.context;
          let avatar = JsxRuntime.jsx(Conversation__ParticipantProfilePhoto.make, {
            participant: from.fragmentRefs,
            size: "micro"
          });
          let msgText;
          if (edges.length !== 1) {
            msgText = " sent you a direct message about ";
          } else {
            let match$4 = edges[0];
            if (match$4 !== undefined) {
              let match$5 = match$4.node.from;
              msgText = match$5.__typename === "Agent" && match$5.id === currentAgentId ? " replied to your direct message about " : " sent you a direct message about ";
            } else {
              msgText = " sent you a direct message about ";
            }
          }
          let match$6 = from.byType;
          let tmp$3;
          tmp$3 = match$6.__typename === "Agent" ? JsxRuntime.jsx(Link, {
              href: `/agents/` + match$6.id,
              children: avatar
            }) : avatar;
          let match$7 = from.byType;
          let tmp$4;
          tmp$4 = match$7.__typename === "Agent" ? JsxRuntime.jsx(Link, {
              href: `/agents/` + id,
              children: match$7.displayName
            }) : "A TAN agent";
          let tmp$5;
          switch (context.__typename) {
            case "BuyerNeedV5" :
              let priceRange = context.priceRange;
              let client = context.client;
              let tmp$6;
              let exit$1 = 0;
              if (client.ok === true) {
                let match$8 = client.value;
                if (match$8 !== undefined) {
                  tmp$6 = JsxRuntime.jsx(Link, {
                    href: `/my_clients/` + match$8.id,
                    children: match$8.displayName
                  });
                } else {
                  exit$1 = 1;
                }
              } else {
                exit$1 = 1;
              }
              if (exit$1 === 1) {
                tmp$6 = JsxRuntime.jsx(Link, {
                  href: `/client_needs/` + id,
                  children: (
                    context.matchingType === "BROADCAST" ? "their buyer need" : "their quiet buyer need"
                  ) + " (" + priceRange.minPrice.formatted + " - " + priceRange.maxPrice.formatted + "/month)"
                });
              }
              tmp$5 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  msgText,
                  tmp$6
                ]
              });
              break;
            case "DevelopmentProject" :
              tmp$5 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  msgText,
                  JsxRuntime.jsx(Link, {
                    href: `/developments/` + context.id,
                    children: Stdlib_Option.getOr(context.name, "their development")
                  })
                ]
              });
              break;
            case "DevelopmentProjectSampleUnit" :
              let unitType = context.unitType;
              let unitType$1 = unitType !== undefined && (unitType === "CONDO" || unitType === "SINGLE_FAMILY") ? (
                  unitType === "CONDO" ? "CONDO" : "SINGLE_FAMILY"
                ) : undefined;
              let unitTitle = DevelopmentSampleUnitSummary.title(unitType$1, context.name);
              tmp$5 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  msgText,
                  JsxRuntime.jsx(Link, {
                    href: `/developments/` + context.development.id + `/units/` + context.id,
                    children: unitTitle
                  })
                ]
              });
              break;
            case "ForSalePropertyV5" :
              let propertyLocation = context.propertyLocation;
              let client$1 = context.propertyClient;
              let displayString;
              switch (propertyLocation.__typename) {
                case "PropertyLocationWithHiddenAddress" :
                  displayString = "their property in " + propertyLocation.locationDisplay;
                  break;
                case "PropertyLocationWithVisibleAddress" :
                  let address = propertyLocation.address;
                  displayString = address !== undefined ? [
                      address,
                      propertyLocation.locationDisplay
                    ].join(" ") : "their property in " + propertyLocation.locationDisplay;
                  break;
                case "__unselected" :
                  displayString = UnselectedUnionMemberError.raise(propertyLocation._0);
                  break;
              }
              let tmp$7;
              let exit$2 = 0;
              if (client$1.ok === true) {
                let match$9 = client$1.value;
                if (match$9 !== undefined) {
                  tmp$7 = JsxRuntime.jsx(Link, {
                    href: `/my_clients/` + match$9.id,
                    children: displayString
                  });
                } else {
                  exit$2 = 1;
                }
              } else {
                exit$2 = 1;
              }
              if (exit$2 === 1) {
                tmp$7 = JsxRuntime.jsx(Link, {
                  href: `/properties/` + id,
                  children: displayString
                });
              }
              tmp$5 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  msgText,
                  tmp$7
                ]
              });
              break;
            case "MessageBroadcast" :
              tmp$5 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  " replied to ",
                  JsxRuntime.jsx(Link, {
                    href: `/messages/` + context.id,
                    children: context.subject
                  })
                ]
              });
              break;
            case "RentalNeedV5" :
              let priceRange$1 = context.priceRange;
              let client$2 = context.client;
              let tmp$8;
              let exit$3 = 0;
              if (client$2.ok === true) {
                let match$10 = client$2.value;
                if (match$10 !== undefined) {
                  tmp$8 = JsxRuntime.jsx(Link, {
                    href: `/my_clients/` + match$10.id,
                    children: match$10.displayName
                  });
                } else {
                  exit$3 = 1;
                }
              } else {
                exit$3 = 1;
              }
              if (exit$3 === 1) {
                tmp$8 = JsxRuntime.jsx(Link, {
                  href: `/client_needs/` + id,
                  children: "their rental need (" + priceRange$1.minPrice.formatted + " - " + priceRange$1.maxPrice.formatted + "/month)"
                });
              }
              tmp$5 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  msgText,
                  tmp$8
                ]
              });
              break;
            case "RentalPropertyV5" :
              let propertyLocation$1 = context.propertyLocation;
              let client$3 = context.propertyClient;
              let displayString$1;
              switch (propertyLocation$1.__typename) {
                case "PropertyLocationWithHiddenAddress" :
                  displayString$1 = "their rental property in " + propertyLocation$1.locationDisplay;
                  break;
                case "PropertyLocationWithVisibleAddress" :
                  let address$1 = propertyLocation$1.address;
                  displayString$1 = address$1 !== undefined ? [
                      address$1,
                      propertyLocation$1.locationDisplay
                    ].join(" ") : "their rental property in " + propertyLocation$1.locationDisplay;
                  break;
                case "__unselected" :
                  displayString$1 = UnselectedUnionMemberError.raise(propertyLocation$1._0);
                  break;
              }
              let tmp$9;
              let exit$4 = 0;
              if (client$3.ok === true) {
                let match$11 = client$3.value;
                if (match$11 !== undefined) {
                  tmp$9 = JsxRuntime.jsx(Link, {
                    href: `/my_clients/` + match$11.id,
                    children: displayString$1
                  });
                } else {
                  exit$4 = 1;
                }
              } else {
                exit$4 = 1;
              }
              if (exit$4 === 1) {
                tmp$9 = JsxRuntime.jsx(Link, {
                  href: `/properties/` + id,
                  children: displayString$1
                });
              }
              tmp$5 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  msgText,
                  tmp$9
                ]
              });
              break;
            case "__unselected" :
              tmp$5 = UnselectedUnionMemberError.raise(context._0);
              break;
          }
          tmp = JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                children: tmp$3,
                className: userPic
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  tmp$4,
                  tmp$5,
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(RelativeDateLabel.make, {
                      date: Scalars.DateTime.toUTC(alert.timestamp)
                    })
                  })
                ],
                className: content
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(Link, {
                  href: `/conversations/` + id,
                  children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                    onClick: param => onDismiss(),
                    size: "small",
                    children: "View message"
                  })
                }),
                className: action
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(AlertsDropdownItem$DismissAlert, {
                  onDismiss: onDismiss
                }),
                className: close
              })
            ],
            className: item
          });
          break;
        case "RemovedConversationContext" :
          let from$1 = s.message.from;
          let id$1 = match$2.id;
          let entityType = match$3.entityType;
          let avatar$1 = JsxRuntime.jsx(Conversation__ParticipantProfilePhoto.make, {
            participant: from$1.fragmentRefs,
            size: "micro"
          });
          let removedLabel;
          if (entityType !== undefined && (entityType === "BROADCAST_MESSAGE" || entityType === "RENTAL_PROPERTY" || entityType === "BUYER_NEED" || entityType === "RENTAL_NEED" || entityType === "DEVELOPMENT_PROJECT" || entityType === "FOR_SALE_PROPERTY" || entityType === "DEVELOPMENT_SAMPLE_UNIT")) {
            switch (entityType) {
              case "BROADCAST_MESSAGE" :
                removedLabel = "Removed Broadcast";
                break;
              case "BUYER_NEED" :
                removedLabel = "Removed Buyer Need";
                break;
              case "DEVELOPMENT_PROJECT" :
                removedLabel = "Removed Development";
                break;
              case "DEVELOPMENT_SAMPLE_UNIT" :
                removedLabel = "Removed Sample Unit";
                break;
              case "FOR_SALE_PROPERTY" :
                removedLabel = "Removed Property";
                break;
              case "RENTAL_NEED" :
                removedLabel = "Removed Rental Need";
                break;
              case "RENTAL_PROPERTY" :
                removedLabel = "Removed Rental Property";
                break;
            }
          } else {
            removedLabel = "Removed Listing";
          }
          let match$12 = from$1.byType;
          let tmp$10;
          tmp$10 = match$12.__typename === "Agent" ? JsxRuntime.jsx(Link, {
              href: `/agents/` + match$12.id,
              children: avatar$1
            }) : avatar$1;
          let match$13 = from$1.byType;
          let tmp$11;
          tmp$11 = match$13.__typename === "Agent" ? JsxRuntime.jsx(Link, {
              href: `/agents/` + id$1,
              children: match$13.displayName
            }) : "A TAN agent";
          tmp = JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                children: tmp$10,
                className: userPic
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  tmp$11,
                  " sent you a direct message about ",
                  JsxRuntime.jsx("span", {
                    children: `[` + removedLabel + `]`,
                    className: "text-zinc-500"
                  }),
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(RelativeDateLabel.make, {
                      date: Scalars.DateTime.toUTC(alert.timestamp)
                    })
                  })
                ],
                className: content
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(Link, {
                  href: `/conversations/` + id$1,
                  children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                    onClick: param => onDismiss(),
                    size: "small",
                    children: "View message"
                  })
                }),
                className: action
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(AlertsDropdownItem$DismissAlert, {
                  onDismiss: onDismiss
                }),
                className: close
              })
            ],
            className: item
          });
          break;
        case "__unselected" :
          tmp = null;
          break;
      }
      break;
    case "__unselected" :
      tmp = UnselectedUnionMemberError.raise(s._0);
      break;
  }
  return JsxRuntime.jsx(RcSwipeout, {
    right: [{
        text: "Dismiss",
        style: {
          backgroundColor: Theme__Color.toString(Theme__Color.crimson),
          color: Theme__Color.toString(Theme__Color.white)
        },
        onPress: onDismiss
      }],
    children: tmp
  });
}

let WithoutErrorBoundary = {
  make: AlertsDropdownItem$WithoutErrorBoundary
};

function AlertsDropdownItem(props) {
  return JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
    FallbackComponent: _error => null,
    children: JsxRuntime.jsx(AlertsDropdownItem$WithoutErrorBoundary, {
      alert: props.alert,
      onDismiss: props.onDismiss
    }),
    onError: error => Sentry.captureException(error, "AlertsDropdownItem.res", undefined, undefined, undefined)
  });
}

let make = AlertsDropdownItem;

exports.Styles = Styles;
exports.Fragment = Fragment;
exports.DismissAlert = DismissAlert;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* IconV5 Not a pure module */
